import api from '../../utils/api';
import {UserSettings} from '@services/UserSettings/types';

export const getUserSettings = (): Promise<UserSettings> => api.get(`/me/settings`);

export const updateUserSettings = (data?: UserSettings): Promise<UserSettings> => api.put('me/settings', data);

export const UserSettingsService = {getUserSettings, updateUserSettings};
